"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_js_1 = __importDefault(require("./native.js"));
const errors_js_1 = require("./errors.js");
function _Buffer(value) {
    return Buffer.isBuffer(value);
}
function Hex(value) {
    return typeof value === 'string' && /^([\da-f]{2})+$/iu.test(value);
}
function _LengthN(type, length) {
    const name = type.toJSON();
    function Length(value) {
        if (!type(value))
            return false;
        if (value.length === length)
            return true;
        throw (0, errors_js_1.tfCustomError)(name + '(Length: ' + length + ')', name + '(Length: ' + value.length + ')');
    }
    Length.toJSON = function () {
        return name;
    };
    return Length;
}
const _ArrayN = _LengthN.bind(null, native_js_1.default.Array);
const _BufferN = _LengthN.bind(null, _Buffer);
const _HexN = _LengthN.bind(null, Hex);
const _StringN = _LengthN.bind(null, native_js_1.default.String);
function Range(a, b, f) {
    const check = f || native_js_1.default.Number;
    function _range(value, ...args) {
        return check(value, ...args) && value > a && value < b;
    }
    _range.toJSON = function () {
        return `${check.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
const INT53_MAX = Math.pow(2, 53) - 1;
function Finite(value) {
    return typeof value === 'number' && isFinite(value);
}
function Int8(value) {
    return (value << 24) >> 24 === value;
}
function Int16(value) {
    return (value << 16) >> 16 === value;
}
function Int32(value) {
    return (value | 0) === value;
}
function Int53(value) {
    return (typeof value === 'number' &&
        value >= -INT53_MAX &&
        value <= INT53_MAX &&
        Math.floor(value) === value);
}
function UInt8(value) {
    return (value & 0xff) === value;
}
function UInt16(value) {
    return (value & 0xff_ff) === value;
}
function UInt32(value) {
    return value >>> 0 === value;
}
function UInt53(value) {
    return (typeof value === 'number' && value >= 0 && value <= INT53_MAX && Math.floor(value) === value);
}
const types = {
    ArrayN: _ArrayN,
    Buffer: _Buffer,
    BufferN: _BufferN,
    Finite: Finite,
    Hex: Hex,
    HexN: _HexN,
    Int8: Int8,
    Int16: Int16,
    Int32: Int32,
    Int53: Int53,
    Range: Range,
    StringN: _StringN,
    UInt8: UInt8,
    UInt16: UInt16,
    UInt32: UInt32,
    UInt53: UInt53,
};
for (const typeName in types) {
    types[typeName].toJSON = function (t) {
        return t;
    }.bind(null, typeName);
}
exports.default = types;
